<template>
  <div class="mv-update-status">
    <table class="mv-update-status__table">
      <tbody>
        <tr>
          <td class="mv-update-status__label">Zustand</td>
          <td>{{ status_text }}</td>
        </tr>
        <tr v-if="state.status === 'running'">
          <td class="mv-update-status__label">Phase</td>
          <td>{{ phase_text }}</td>
        </tr>
        <tr v-if="state.message">
          <td class="mv-update-status__label">Meldung</td>
          <td>{{ state.message }}</td>
        </tr>
        <tr>
          <td class="mv-update-status__label">Offene Updates</td>
          <td>{{ state.pending === null ? 'nie ermittelt' : state.pending }}</td>
        </tr>
        <tr v-if="zeigt_durchlauf">
          <td class="mv-update-status__label">Durchlauf</td>
          <td>{{ state.cycle }} von {{ state.max_cycles }}</td>
        </tr>
        <tr v-if="zeigt_durchlauf">
          <td class="mv-update-status__label">Neustarts</td>
          <td>{{ state.reboots }}</td>
        </tr>
        <tr v-if="state.started">
          <td class="mv-update-status__label">Begonnen</td>
          <td>{{ zeit(state.started) }}</td>
        </tr>
        <tr v-if="state.finished">
          <td class="mv-update-status__label">Beendet</td>
          <td>{{ zeit(state.finished) }} ({{ dauer }})</td>
        </tr>
      </tbody>
    </table>

    <div class="mt-2 subtitle-2">Installierte Updates</div>
    <div
      v-if="state.installed.length === 0"
      class="caption"
    >
      In diesem Lauf wurde nichts installiert.
    </div>
    <table
      v-else
      class="mv-update-status__table"
    >
      <tbody>
        <tr
          v-for="(update, index) in state.installed"
          :key="index"
        >
          <td>{{ update.title }}</td>
          <td class="mv-update-status__label">{{ update.kb }}</td>
          <td :class="result_color(update.result)">{{ update.result }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "mv-update-status",
  // Eigene Komponente, damit die Kachel in VNCView.vue schlank bleibt: der
  // vollstaendige Update-Zustand haengt am Hinweisfenster des Update-Knopfes.
  props: {
    machine: { type: Object, default: null }
  },
  computed: {
    state(){
      if(this.machine === null || !this.machine.update){
        return { status: 'idle', phase: null, scan_only: false, auto: false, cycle: 0, max_cycles: 0, reboots: 0, pending: null, installed: [], message: '', started: null, finished: null }
      }
      return this.machine.update
    },
    status_text(){
      let texte = { idle: 'Noch kein Lauf', queued: 'Warteschlange', running: 'Läuft', done: 'Abgeschlossen', error: 'Fehler', unreachable: 'Nicht erreichbar' }
      // Ein reiner Scan installiert nichts - "Abgeschlossen" wuerde nach einem
      // erfolgreichen Update-Lauf aussehen, obwohl nur gesucht wurde.
      if(this.state.status === 'done' && this.state.scan_only) return 'Suche abgeschlossen'
      return texte[this.state.status] || this.state.status
    },
    phase_text(){
      let phasen = { wecken: 'Rechner wecken', warten: 'Warten auf den Rechner', suchen: 'Updates suchen', installieren: 'Updates installieren', neustart: 'Neustart', herunterfahren: 'Herunterfahren' }
      return phasen[this.state.phase] || 'Läuft'
    },
    zeigt_durchlauf(){
      // Bei einer reinen Suche ist die Obergrenze fest 1 und es wird nie neu
      // gestartet - "1 von 1" und "0" waeren dort nur Rauschen.
      return !this.state.scan_only && this.state.cycle > 0
    },
    dauer(){
      if(!this.state.started || !this.state.finished) return ''
      let sekunden = Math.round((new Date(this.state.finished) - new Date(this.state.started)) / 1000)
      let minuten = Math.floor(sekunden / 60)
      return minuten > 0 ? minuten + ' min ' + (sekunden % 60) + ' s' : sekunden + ' s'
    }
  },
  methods: {
    zeit(wert){
      // Das Backend liefert UTC mit Offset; die Anzeige rechnet in die lokale Zeit.
      return new Date(wert).toLocaleString('de-DE')
    },
    result_color(result){
      // Faerbt das Ergebnis je Update ein, damit ein einzelnes FEHLER zwischen
      // vielen OK auffaellt statt im Fliesstext unterzugehen.
      if(result === 'OK') return 'success--text'
      if(result === 'TEILWEISE') return 'warning--text'
      if(result === 'FEHLER') return 'error--text'
      return ''
    }
  }
};
</script>

<style scoped>
/* Eine schlichte Tabelle statt v-simple-table: die Darstellung muss sowohl auf
   der hellen Karte des Dialogs als auch auf dem dunklen Grund des
   Hinweisfensters sitzen - eine Tabelle mit eigenem Hintergrund tut das nicht. */
.mv-update-status__table {
  border-collapse: collapse;
  width: 100%;
}
.mv-update-status__table td {
  padding: 1px 8px 1px 0;
  vertical-align: top;
  line-height: 1.35;
}
.mv-update-status__label {
  white-space: nowrap;
  opacity: 0.75;
}
</style>
